export class Tabs {
  constructor() {
    this._tabsContainer = document.querySelectorAll('.s-typo-adherent-list');

    if (this._tabsContainer.length) {
      this.init();
    }
  }

  init() {
    this._tabsContainer.forEach((list) => {
      let tabs = list.querySelectorAll('.c-tab');
      let panels = list.querySelectorAll('.c-panel');

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          tabs.forEach((t) => t.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));

          tab.classList.add('active');
          panels[index].classList.add('active');
        })
      })

    })
  }
}
